import { render, staticRenderFns } from "./TaskManager2.vue?vue&type=template&id=43eb605e&scoped=true&"
import script from "./TaskManager2.vue?vue&type=script&lang=js&"
export * from "./TaskManager2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43eb605e",
  null
  
)

export default component.exports